import React from "react";
import ReactDOM from "react-dom";
import {
  Table,
  Button,
  UncontrolledDropdown,
  UncontrolledTooltip,
  ButtonGroup,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Badge
} from "reactstrap";
import FooterPagination from "../../Pagination/FooterPagination";
import { capitalizeFirstLetter } from "../../../utils/utils";
import { useNavigate } from "react-router-dom";
import { INDIVIDUAL_STATUS } from "../../../constants";
import UserStatusBadge from "../../../Components/Badges/UserStatusBadge";
import EditEmployeeModal from "../../modals/EmployeesModal/EditEmployeeModal";
import moment from "moment";

const IndividualsTable = ({
  data,
  onRefreshTable,
  isInactive,
  paginationProps,
  activeTab,
  onDelete,
  searchDone,
  searchParam,
}) => {
  const navigate = useNavigate();
  const handleViewProfile = (item) => {
    navigate(`/individuals/profile/${item.id}`);
  };

  const isInvited = activeTab == 3;

  const isNotSearchResult = searchParam && !data.length && searchDone;
  const noData = data.length === 0 && !searchParam;

  const [openEditModal, setOpenEditModal] = React.useState(false);
  const [individual, setIndividual] = React.useState();

  const handleOpenEditModal = (item) => {
    setOpenEditModal(true);
    setIndividual(item);
  };

  const handleDeleteIndividual = (item) => {
    onDelete(item);
  };

  const renderDropdownMenu = (item) => {
    // const isTerminated = item.active !== true;
    const portalRoot = document.getElementById("portal-root");
    return portalRoot
      ? ReactDOM.createPortal(
        <DropdownMenu>
          <DropdownItem
            onClick={() => handleViewProfile(item)}
            className="edit-item-btn"
          >
            <i className="ri-eye-fill align-bottom me-2 text-muted"></i>
            View
          </DropdownItem>

          {isInactive || isInvited ? (
            <>
              <DropdownItem
                onClick={() => handleDeleteIndividual(item)}
                className="d-flex align-items-center"
              >
                <i className="ri-delete-bin-fill align-bottom me-2 text-muted"></i>
                Delete
              </DropdownItem>
            </>
          ) : (
            <>
              <DropdownItem
                className="edit-item-btn"
                onClick={() => handleOpenEditModal(item)}
              >
                <i className="ri-pencil-fill align-bottom me-2 text-muted"></i>
                Edit
              </DropdownItem>
            </>
          )}
        </DropdownMenu>,
        portalRoot
      )
      : null;
  };

  // Helper function to determine tier display
  const renderTier = (individual) => {
    const tier = individual.tier || "I";
    const tierLabel = tier === "I" ? "Individual" : "Family";
    const tierColor = tier === "I" ? "primary" : "success";

    return (
      <span className="d-inline-block" title={tierLabel}>
        <Badge color={tierColor} pill className="px-2">
          {tier}
        </Badge>
      </span>
    );
  };

  return (
    <>
      {openEditModal && (
        <EditEmployeeModal
          isIndividual
          open={openEditModal}
          editUser={individual}
          setOpen={setOpenEditModal}
          setUser={setIndividual}
          onRefreshTable={onRefreshTable}
        />
      )}
      <Table className="table table-hover border table-centered align-middle table-nowrap mb-0">
        <thead className="bg" style={{ background: "var(--thead-bg)" }}>
          <tr>
            <th scope="col">First Name</th>
            <th scope="col">Last Name</th>
            <th scope="col">Email</th>
            <th scope="col">Date Added On</th>

            <th scope="col" className="text-center">
              Tier
            </th>
            <th scope="col" className="text-center">
              Status
            </th>
            <th scope="col" className="text-center">
              Manage
            </th>
          </tr>
        </thead>
        <tbody>
          {isNotSearchResult && (
            <tr>
              <td className="text-center" colSpan="12">
                No search results for "{searchParam}"
              </td>
            </tr>
          )}

          {noData ? (
            <tr>
              <td className="text-center" colSpan="12">
                No individuals found.
              </td>
            </tr>
          ) : (
            data.map((individual, index) => {
              const statusBadgeClass =
                individual.status === "active"
                  ? "success"
                  : individual.status === INDIVIDUAL_STATUS.INVITED
                    ? "info"
                    : "danger";

              return (
                <tr
                  key={index}
                  className="cursor-pointer"
                  onClick={() => handleViewProfile(individual)}
                >
                  <td> {individual.firstName || "-"}</td>
                  <td>{individual.lastName || "-"}</td>
                  <td>{individual.email}</td>
                  <td>{individual.createdAt ?
                    moment(individual.createdAt).format("MM/DD/YYYY") : "-"}</td>
                  <td className="text-center">
                    {renderTier(individual)}
                  </td>
                  <td className="text-center">
                    <UserStatusBadge
                      status={individual.status}
                      color={statusBadgeClass}
                    />
                  </td>
                  <td className="text-center">
                    <ButtonGroup onClick={(e) => e.stopPropagation()}>
                      <UncontrolledDropdown className="dropdown d-inline-block">
                        <DropdownToggle
                          tag="button"
                          className="btn btn-soft-primary  btn-sm"
                        >
                          <i className="ri-more-fill align-middle"></i>
                        </DropdownToggle>
                        {renderDropdownMenu(individual)}
                      </UncontrolledDropdown>
                    </ButtonGroup>
                  </td>
                </tr>
              );
            })
          )}
        </tbody>
        {paginationProps.totalItems > 0 && (
          <tfoot>
            <FooterPagination
              itemsCount={paginationProps.itemsCount}
              totalPages={paginationProps.totalPages}
              totalItems={paginationProps.totalItems}
              currentPage={paginationProps.currentPage}
              onChangePage={paginationProps.onChangePage}
              onChangePageSize={paginationProps.onChangePageSize}
            />
          </tfoot>
        )}
      </Table>
    </>
  );
};

export default IndividualsTable;